import styled from "styled-components";

export const AssignmentLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 0;
`;

export const ContainerAssignment = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  border: 1px solid #f0f0f0;
  width: 100%;
  border-radius: 5px;
  padding-inline: 15px;
  padding-block: 5px;
  padding-top: 25px;
`;

export const AssignmentItems = styled.div<{ hidden?: boolean }>`
  display: ${({ hidden }) => (hidden ? "none" : "flex")};
  gap: 10px;
`;
